<ng-container
    *ngIf="uiLayout === uiLayoutEnum.AKKORDEON_MENU_NACH_GRUPPEN">
  <ng-container
      *ngFor="let gruppe of menu?.UIMenuGruppen,trackBy: trackByGruppe">
    <mat-expansion-panel [expanded]="(selectedMenuItem$ | async) === gruppe.Identifikator"
                         (opened)="onSectionSelected(gruppe.Identifikator)">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ gruppe.MenuTitel }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container
          *ngFor="let seite of gruppe?.UIMenuSeiten,trackBy: trackBySeite">
        <lv-uiartefakt-container class="lv-artefakt-tab"
                                 [uiArtefakte]="seite.UIArtefakt">
        </lv-uiartefakt-container>
      </ng-container>
      <div class="lv-pflichtfeld-hinweis" *ngIf="hasPflichtfelder.get(gruppe.Identifikator)" [innerHTML]="'INFOTEXT.PFLICHTFELD_ANGABE' | translate"></div>
      <div class="lv-weiter-zurueck-buttons" *ngIf="showWorkflowButtons">
        <button [ngClass]="{'lv-hidden-weiter-zurueck-buttons': !gruppe.ZurueckButtonLabel}" mat-raised-button (click)="onZurueckClicked()">{{gruppe.ZurueckButtonLabel}}</button>
        <button [ngClass]="{'lv-hidden-weiter-zurueck-buttons': !gruppe.WeiterButtonLabel}" mat-raised-button (click)="onWeiterClicked()">{{gruppe.WeiterButtonLabel}}</button>
      </div>
    </mat-expansion-panel>
  </ng-container>
</ng-container>

<ng-container *ngIf="uiLayout === uiLayoutEnum.AKKORDEON_MENU_NACH_SEITEN">
  <ng-container
      *ngFor="let gruppe of menu?.UIMenuGruppen,trackBy: trackByGruppe">
    <ng-container
        *ngFor="let seite of gruppe?.UIMenuSeiten,trackBy: trackBySeite">
      <mat-expansion-panel [expanded]="(selectedMenuItem$ | async) === seite.Identifikator"
                           (opened)="onSectionSelected(seite.Identifikator)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ seite.MenuTitel }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <lv-uiartefakt-container class="lv-artefakt-tab"
                                 [uiArtefakte]="seite.UIArtefakt">
        </lv-uiartefakt-container>
        <div class="lv-pflichtfeld-hinweis" *ngIf="hasPflichtfelder.get(seite.Identifikator)" [innerHTML]="'INFOTEXT.PFLICHTFELD_ANGABE' | translate"></div>
        <div class="lv-weiter-zurueck-buttons" *ngIf="showWorkflowButtons">
          <button [ngClass]="{'lv-hidden-weiter-zurueck-buttons': !seite.ZurueckButtonLabel}" mat-raised-button (click)="onZurueckClicked()">
            <div *ngIf="!!uiControlsRequestPending && clickedButton === 'zurueck'" class="lv-button-spinner">
              <mat-progress-spinner class="lv-progress-spinner-black" mode="indeterminate" [diameter]="20"></mat-progress-spinner>
            </div>
            <div [ngClass]="{'lv-hide-zurueck-label': !!uiControlsRequestPending && clickedButton === 'zurueck'}">
              {{seite.ZurueckButtonLabel}}
            </div>
          </button>
          <button [ngClass]="{'lv-hidden-weiter-zurueck-buttons': !seite.WeiterButtonLabel}" mat-raised-button (click)="onWeiterClicked()">
            <div *ngIf="!!uiControlsRequestPending && clickedButton === 'weiter'" class="lv-button-spinner">
              <mat-progress-spinner class="lv-progress-spinner-black" mode="indeterminate" [diameter]="20"></mat-progress-spinner>
            </div>
            <div [ngClass]="{'lv-hide-weiter-label': !!uiControlsRequestPending && clickedButton === 'weiter'}">
              {{seite.WeiterButtonLabel}}
            </div>
          </button>
        </div>
      </mat-expansion-panel>
    </ng-container>
  </ng-container>
</ng-container>
